"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const Sankey_1 = __importDefault(require("./Sankey"));
class LeftSankey extends Sankey_1.default {
  // Doesn't use this but can't be static because it needs to override Sankey
  // eslint-disable-next-line class-methods-use-this
  color(params) {
    return params.secondaryColor || params.primaryColor;
  }
  xAccessor(xStart, level, numSankeys, width) {
    return xStart - this.xOffset(level) / numSankeys - width;
  }
  xLabel(xStart, level, numSankeys) {
    const width = this.nodeWidths[level] / numSankeys;
    const x = this.xAccessor(xStart, level, numSankeys, width);
    return x + width * 0.95;
  }
  xStart(numSankeys) {
    return this.containerWidth - (this.containerWidth + this.middlePadding) / 2 * (numSankeys - 1);
  }
  drawLabel(nodeG, x, y, categoryHeight, datum) {
    super.drawLabel(nodeG, x, y, categoryHeight, datum, 'end');
  }
  drawLinkLevel(branchG, node, params, offsets, level, numSankeys) {
    const {
      yOffset,
      yOffsetWithPadding
    } = offsets;
    const start = this.xStart(numSankeys);
    const width = this.nodeWidths[level] / numSankeys;
    const x = this.xAccessor(start, level, numSankeys, width);
    const scaledValue = this.heightScale(Math.abs(node.total));
    const prevOffset = start - this.nodeWidths[level - 1] / numSankeys;
    const path = branchG.append('path').classed('sankey-link', true).attr('fill', node.total < 0 ? 'rgb(100,100,100)' : this.color(params)).attr('d', `
                M${prevOffset},${yOffset - this.nodeOffset}
                L${x + width},${yOffsetWithPadding}
                L${x + width},${yOffsetWithPadding + scaledValue}
                L${prevOffset},${yOffset - this.nodeOffset + scaledValue}
            `);
    if (node.linkClass) {
      path.classed(node.linkClass, true);
    }
  }
}
exports.default = LeftSankey;